import { css } from "styled-components";

export const drawerStyle = css`
    .dit-components-drawer {
        .dit-components-drawer-positioner {
            &:is(.left, .right) {
                &.full {
                    inset-inline: 0;
                    max-inline-size: unset;
                }

                .dit-components-drawer-content {
                    overflow-y: auto;
                }
            }
        }
    }

    // Wrapping the drawer with a styled component breaks since the content ends up
    // in a portal and thus not a child of the wrapper. Also, the close button
    // in the drawer content is a sibling of the {children} passed in
    :is(.sidemenu-mobile, .user-menu-mobile).dit-components-drawer {
        .dit-components-drawer-close-button {
            svg {
                height: 1.5rem;
                width: 1.5rem;
            }

            &.dit-components-btn-tertiary {
                color: var(--dit-brand-color-neutral-00);
                background-color: transparent;
                border-color: transparent;
                width: 1.5rem;
                height: 1.5rem;

                &:focus:not(:disabled):not(.disabled),
                &:focus-visible:not(:disabled):not(.disabled) {
                    position: relative;
                    &::after {
                        box-shadow: var(--dit-layout-shadow-header-item-focus--map);
                    }
                }
                &:hover:not(:disabled):not(.disabled) {
                    border-color: transparent;
                    background-color: transparent;
                }
            }
        }
    }
`;
